import { getStorageItem, setStorageItem, WebStorageType } from "../../../common-deprecated/utils/storageUtils";
import type { UscContext } from "../../shared-logic/types/UscCommonTypes";
import type { UscStateType } from "../redux/store";

// ----------------------------------------------------------------------
// Helper types and consts
// ----------------------------------------------------------------------
const LOCAL_STORAGE_ID = "com.toyota.tme.t1.usedStockCars";

export type UscLocalStorageItemType = { visitedVehicleIds?: string[] };

export type UscLocalStorageParams = {
    context: UscContext;
    country: string;
    language: string;
};

// ----------------------------------------------------------------------
// Storage fns
// ----------------------------------------------------------------------
export const getUscLocalStorage = (params: UscLocalStorageParams): UscLocalStorageItemType | null => {
    return getStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, WebStorageType.local);
};

export const setUscLocalStorage = (params: UscLocalStorageParams, storageItem: UscLocalStorageItemType): void => {
    setStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, storageItem, WebStorageType.local);
};

export const getVisitedVehicleIds = (params: UscLocalStorageParams): string[] => {
    return getUscLocalStorage(params)?.visitedVehicleIds || [];
};

export const addVisitedVehicleId = (params: UscLocalStorageParams, vehicleForSaleId: string): void => {
    const visitedVehicleIds = getVisitedVehicleIds(params);
    visitedVehicleIds.push(vehicleForSaleId);

    setUscLocalStorage(params, { visitedVehicleIds });
};

export const uscLocalStorageParamSelector = ({ commonSettings, vehicle }: UscStateType): UscLocalStorageParams => ({
    country: commonSettings.country,
    language: commonSettings.language,
    context: vehicle.type,
});
